import styled from 'styled-components';
import colors from 'constants/colors';

export const ItemRendererContainer = styled.div`
  width: 100%;
  height: 44px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  font-size: 14px;
  color: ${colors.white};

  .row {
    width: 100%;
    line-height: 24px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;

    .increase {
      width: 50%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      font-weight: bold;
      color: ${colors.lightGreen};
    }

    .decrease {
      width: 50%;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: nowrap;
      font-weight: bold;
      color: ${colors.red};
    }

    .textHighlight {
      font-weight: bold;
      color: ${colors.white};
    }

    .text {
      width: 50%;
      color: ${(props) => props.today ? colors.white: null};
    }
  }
`;

export const SideBarItemContainer = styled.div`
  cursor: pointer;
  height: ${(props) => props.rowHeight ? props.rowHeight + 'px' : '44px'};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  padding: 8px 15px;
  color: ${colors.silver};
`;

export const SubHeaderContainer = styled.div`
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: black;
  color: white;
  padding-left: 10px;

  .contentContainer {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-left: 10px;
    margin-bottom: 10px;

    .title {
      font-size: 12px;
      letter-spacing: 1px;
      color: ${colors.silver};
      margin-right: 15px;
    }

    .dateSection {
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 170px;
    }
  }
`;